module.exports = __webpack_public_path__ + "media/Main-Page-Unilux2.a5069ebe.mp4";